import React, { FC, forwardRef } from 'react'
import {
  InputContainer,
  InputLabel,
  InputBox,
  InputInvalidInformation,
} from './styles'

interface InputTextProps {
  placeholder: string
  onSubmit: (value: string) => void
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
  isValid?: boolean
  InvalidInfo?: FC | null
  name?: string
  type?:
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'reset'
    | 'search'
    | 'submit'
    | 'tel'
    | 'text'
    | 'time'
    | 'url'
    | 'week'
}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  (
    {
      placeholder,
      onSubmit,
      isValid = true,
      type = 'text',
      InvalidInfo,
      onChange,
      name
    },  
    ref
  ) => (
    <InputContainer>
      <InputBox
        aria-invalid="false"
        isValid={isValid}
        onKeyPress={(e) =>
          e.key === 'Enter' ? onSubmit(e.currentTarget.value) : null
        }
        onChange={onChange}
        ref={ref}
        data-testid="modal-input"
        type={type}
        placeholder=" "
        name={name}
      />
      <InputLabel data-testid="modal-label">{placeholder}</InputLabel>
      {!isValid && InvalidInfo && (
        <InputInvalidInformation>
          <InvalidInfo />
        </InputInvalidInformation>
      )}
    </InputContainer>
  )
)

export default InputText
